import { createSlice } from '@reduxjs/toolkit';
import { post } from '../../api';

export const paymentSlice = createSlice({
    // Slice name, this should be always as page name.
    name: 'payment',

    // Initial state for the slice
    initialState: {
        data: {},
        status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
        error: null,
    },

    // Reducers will mutate the state, put all the state mutation method over here
    reducers: {
        initialize: (state, action) => {
            state.data = action.payload;
            state.status = 'succeeded';
            state.error = null;
        },
        error: (state, action) => {
            state.status = 'failed';
            state.error = action.payload;
        },
        loading: (state, action) => {
            state.status = action.payload ? 'loading' : 'succeeded';
        },
        initialLoading: (state, action) => {
            state.status = action.payload ? 'initialLoading' : 'succeeded';
        },
        updateMethod: (state, action) => {
            state.data.records = state.data.records.map((item) => {
                if (item.id === action.payload.selectedOrder.id) {
                    return { ...item, ...action.payload.selectedOrder };
                }
                return item;
            });
        },
    },
});

export default paymentSlice.reducer;

// Export all the reducers actions here
export const { initialize, error, loading, initialLoading, updateMethod } = paymentSlice.actions;

// Public Selectors
export const selectPaymentData = (state) => state.payment.data;
export const selectPaymentStatus = (state) => state.payment.status;
export const selectPaymentError = (state) => state.payment.error;

export const initializeAsync = (params) => async (dispatch) => {
    dispatch(initialLoading(true));
    const result = await post('custom/getRecurringPaymentDetails', { accountIds: params.accountIds });
    if (result.isSuccess) {
        dispatch(
            initialize({
                records: result.data,
            })
        );
    } else {
        dispatch(error(result.errorMessage));
    }
};

export const updateMethodAsync = (params) => async (dispatch) => {
    let selectedMethod = params.selectedMethod;
    let selectedOrder = params.selectedOrder;
    selectedOrder = {
        ...selectedOrder,
        paymentMethodDefaultId: selectedMethod.id,
        ccExpiringSoon: selectedMethod.ccExpiringSoon,
        cardExpirationMonth: selectedMethod.cardExpirationMonth,
        cardExpirationYear: selectedMethod.cardExpirationYear,
        cardType: selectedMethod.cardType,
        cardLast4: selectedMethod.cardLast4,
    };
    dispatch(updateMethod({ selectedOrder }));
    const result = await post('custom/updatePaymentMethod', { orderId: selectedOrder.id, paymentMethodId: selectedMethod.id });
    if (result.isSuccess) {
        let messageDetail = { variant: 'success', message: 'Successfully updated the payment method' };
        const event = new CustomEvent('openToster', {
            detail: messageDetail,
        });
        document.dispatchEvent(event);
    }
};

export const addMethodAsync = (params) => async (dispatch) => {
    let selectedMethod = params.selectedMethod;
    let selectedOrder = params.selectedOrder;
    let data = params.data;
    selectedOrder = {
        ...selectedOrder,
        paymentMethodDefaultId: selectedMethod.id,
        ccExpiringSoon: false,
        cardExpirationMonth: data.cardExpirationMonth,
        cardExpirationYear: data.cardExpirationYear,
        cardType: data.cardType,
        cardLast4: data.creditCardNumber.slice(-4),
    };
    dispatch(updateMethod({ selectedOrder }));
};
